import { ApolloClient } from '@apollo/client';
import { StaticDataQuery, StaticFooterDataQuery } from '../../graphql/graphql';
import { getStaticFooterData, getStaticDataQuery } from '../../api/queries';
import Bugsnag from '../bugsnag';

export const getStaticData = async (
  apolloClient: ApolloClient<unknown>,
  withCategories = false
): Promise<void> => {
  try {
    if (withCategories) {
      await apolloClient.query<StaticDataQuery>({
        query: getStaticDataQuery
      });
      return;
    }
    await apolloClient.query<StaticFooterDataQuery>({
      query: getStaticFooterData
    });
  } catch (e) {
    console.error(e);
    const errorCode = e?.networkError?.response?.status || null;
    Bugsnag.notify(
      new Error(`[SSR] Error in getStaticData, status code: ${errorCode}`)
    );
  }
};
